import { ImageProps } from "@omni/types/components/props/image.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useImpressionTracking } from "@/hooks/tracking/useImpressionTracking.hook";

import { Img } from "./components/img/img";
import { ImageContextProvider } from "./context/image.context";

export const Base = ({
    src,
    className,
    desktop,
    mobile,
    children,
    trackingProps,
    intersectionOptions,
    ...props
}: RequireChildrenFor<ImageProps>) => {
    const { ref } = useImpressionTracking(trackingProps, intersectionOptions);

    return (
        <ImageContextProvider
            src={src}
            desktop={desktop}
            mobile={mobile}
            {...props}
        >
            <picture
                ref={ref}
                className={cn("tw:w-full tw:h-auto", className)}
            >
                {isDefined(mobile) && (
                    <source
                        srcSet={mobile.srcSet ?? undefined}
                        media={mobile.media ?? undefined}
                        width={mobile.width ?? undefined}
                        height={mobile.height ?? undefined}
                    />
                )}
                {children && children}
                {!children && <Img />}
            </picture>
        </ImageContextProvider>
    );
};
